import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.anchorReply())),
    class: "w-full flex flex-col text-left cursor-pointer"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Icon, {
        name: "Append",
        size: "17"
      }),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.getUserName) + " " + _toDisplayString(_ctx.msgPosition) + " um documento ", 1)
    ])
  ]))
}